import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { getQuote } from "../../../Quotes";
import Skeleton from "react-loading-skeleton";
import ResumeContent from "./Contents/ResumeContent";
import ImpressionsContent from "./Contents/ImpressionsContent";
import useWindowDimensions from "../../../../hooks/useWindowDimension";
import "./style.css";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { BsToggle2Off, BsToggle2On } from "react-icons/bs";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

export default function PrimaryCard({ generatedImpressions, assetId, report }) {
  const [selectedContent, setSelectedContent] = useState("RESUME");

  useEffect(() => {
    setSelectedContent("RESUME");
  }, [assetId]);

  const { width } = useWindowDimensions();

  if (!generatedImpressions) {
    return loadingSkeleton();
  }

  function handleBlockClick() {
    if (selectedContent === "RESUME") {
      return setSelectedContent("IMPRESSIONS");
    }

    return setSelectedContent("RESUME");
  }

  function getSwitcher() {
    const enabledStyle = { cursor: "default", color: "var(--primary-blue)" };
    const disabledStyle = { cursor: "default" };
    const impressionIcon = (
      <BsToggle2Off
        cursor={"pointer"}
        color="var(--primary-blue)"
        style={{ marginTop: -6, marginBottom: 10 }}
        onClick={() => setSelectedContent("RESUME")}
        size={30}
      />
    );
    const resumeIcon = (
      <BsToggle2On
        cursor={"pointer"}
        color="var(--primary-blue)"
        onClick={() => setSelectedContent("IMPRESSIONS")}
        style={{ marginTop: -6, marginBottom: 10 }}
        size={30}
      />
    );

    return (
      <div
        className={`d-flex justify-content-${width > 768 ? "start" : "center"}`}
        style={{ maxWidth: "content" }}
        onClick={() => handleBlockClick()}
      >
        <span
          className={`mg-r-10 not-selectable`}
          style={
            selectedContent === "IMPRESSIONS" ? enabledStyle : disabledStyle
          }
        >
          Impressões
        </span>

        {selectedContent === "IMPRESSIONS" ? impressionIcon : resumeIcon}

        <span
          className={`mg-l-10 not-selectable overflow-switch-text`}
          style={selectedContent === "RESUME" ? enabledStyle : disabledStyle}
        >
          Natural Language
        </span>
      </div>
    );
  }

  if (selectedContent === "IMPRESSIONS") {
    return (
      <ImpressionsContent
        generatedImpressions={generatedImpressions}
        assetId={assetId}
        switchElement={getSwitcher()}
      />
    );
  }

  return (
    <ResumeContent
      report={report}
      switchElement={getSwitcher()}
      assetId={assetId}
    />
  );
}

export const ImpressionsCardMemo = React.memo(PrimaryCard);

const loadingSkeleton = () => {
  let loadingQuote = getQuote();
  if (isMobile) {
    return (
      <div className="card card-dashboard-thirteen animated fadeInDown">
        <div>
          <center>
            <Skeleton width={"70%"} />
          </center>
          <div className="quotes">
            <center>
              <p className="update_text">
                <i>{loadingQuote.quote}</i>
              </p>
              <p>
                <b>{"- " + loadingQuote.author}</b>
              </p>
              <Skeleton count={3} />
            </center>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="card card-dashboard-thirteen animated fadeInDown">
        <div>
          <div style={{ marginLeft: 5 }}>
            <Skeleton width={"40%"} />
          </div>
          <div className="quotes">
            <center>
              <p className="update_text">
                <i>{loadingQuote.quote}</i>
              </p>
              <p>
                <b>{"- " + loadingQuote.author}</b>
              </p>
              <Skeleton count={7} />
            </center>
          </div>
        </div>
      </div>
    );
  }
};
